// extracted by mini-css-extract-plugin
export default {"wrapper":"SelectorSkeleton_wrapper__9HxZR","clickableBlock":"SelectorSkeleton_clickableBlock__y-MhY","value":"SelectorSkeleton_value__1eaCo"};